	<mat-toolbar>
	<!-- 	<a mat-icon-button [routerLink]="['/home']" aria-label="Back to home">
			<mat-icon>arrow_back_ios_new</mat-icon>
		</a> -->
		<span>{{"SEARCH.SEARCH" | translate}}</span>
	</mat-toolbar>
    <div class="app-page">


	<div class="search-options">
		<a mat-raised-button color="primary" [routerLink]="['/search/player']">
			<mat-icon>person_search</mat-icon>
			{{"SEARCH.PLAYER_SEARCH" | translate}}
		</a>

		<a mat-raised-button color="primary" [routerLink]="['/search/report']">
			<mat-icon>description</mat-icon>
			{{"SEARCH.REPORT_SEARCH" | translate}}
		</a>

		<a mat-raised-button color="primary" [routerLink]="['/search/favourites']">
			<mat-icon>star</mat-icon>
			{{"SEARCH.FAVOURITE_PLAYERS" | translate}}
		</a>

		<a mat-raised-button color="primary" [routerLink]="['/search/tags']">
			<mat-icon>sell</mat-icon>
			{{"SEARCH.PLAYERS_BY_TAG" | translate}}
		</a>
	</div>
</div>
